export default "__VITE_ASSET__BwjufWvt__"